if (typeof Shopify === 'undefined' || !Shopify.designMode) {
  
  document.addEventListener('DOMContentLoaded', () => {
    
    const modalTriggers = document.querySelectorAll('[data-modal-trigger]');
    
    // Funciones de control
    const openModal = (modalId) => {
      const modal = document.getElementById(modalId);
      if (modal) {
        modal.classList.add('is-vis');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('no-scroll');
      }
    };

    const closeModal = (modal) => {
      modal.classList.remove('is-vis');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('no-scroll');
    };

    // --- Lógica de Triggers Manuales ---
    modalTriggers.forEach(trigger => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        const modalId = trigger.dataset.modalTrigger;
        openModal(modalId);
      });
    });

    // --- Lógica de Apertura Automática --
    // Buscamos cualquier modal que tenga el atributo data-auto-open
    const autoModal = document.querySelector('.n-modal[data-auto-open]');
    if (autoModal) {
      const modalId = autoModal.id;
    
      if (!sessionStorage.getItem(modalId + '-shown')) {
        setTimeout(() => {
          openModal(modalId);
          sessionStorage.setItem(modalId + '-shown', 'true');
        }, 2000);
      }
    }

    // --- Lógica de Cierre (Botones y Overlay) ---
    document.querySelectorAll('[data-modal-close]').forEach(closeElement => {
      closeElement.addEventListener('click', () => {
        const modal = closeElement.closest('.n-modal');
        if (modal) closeModal(modal);
      });
    });

    // --- Tecla Escape ---
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        const visibleModal = document.querySelector('.n-modal.is-vis');
        if (visibleModal) closeModal(visibleModal);
      }
    });
  });
}